//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import Container from 'react-bootstrap/Container';

import { Navigation, UserInfoBar } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { LoginPanel, ResetPassPanel } from '../auth';

import './HomeLayout.css';

export function HomeLayout({
    children
}) {

    return (
        <main>
            <Navigation />
            <UserInfoBar />
            <Container className="main-content p-0" fluid>
                {children}
            </Container>
            <Footer />

            <LoginPanel />
            <ResetPassPanel />
        </main>
    );
}

